import { createContext, useContext } from 'react';
import type { DevicePreference, useEasyRtc } from './useEasyRtc';

export interface RtcSessionDescriptor {
  id: string;
  kind: 'meeting' | 'call';
  title: string;
  startWithVideo: boolean;
  startWithAudio?: boolean;
  /** Devices chosen in the lobby, honoured by the initial capture. */
  devices?: DevicePreference;
}

export interface RtcSessionContextValue {
  session: RtcSessionDescriptor | null;
  rtc: ReturnType<typeof useEasyRtc>;
  primaryStream: MediaStream | null;
  primaryLabel: string;
  primaryIsLocal: boolean;
  pipSupported: boolean;
  startSession: (session: RtcSessionDescriptor) => void;
  endSession: () => void;
  enterPictureInPicture: () => Promise<void>;
}

export const RtcSessionContext = createContext<RtcSessionContextValue | null>(null);

export function useRtcSession(): RtcSessionContextValue {
  const value = useContext(RtcSessionContext);
  if (!value) throw new Error('useRtcSession must be used inside RtcSessionProvider');
  return value;
}
